<template>
  <section>
    <p v-scroll-reveal="{ delay: 200 }" class="first">
      {{ data_p1contact[this.lang] }}
    </p>
    <p v-html="data_p2contact[this.lang]" v-scroll-reveal="{ delay: 400 }" class="second"></p>
  </section>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_p1contact: {
        EN: 'We’d love to chat about your business and how we can partner with you.',
        ES: 'Nos encantaría charlar sobre tu negocio y cómo podemos asociarnos contigo.'
      },
      data_p2contact: {
        EN: `Get in touch at <a class="highlight" href="mailto:hello@diwa.studio">hello@diwa.studio</a>`,
        ES: `Contáctanos a <a class="highlight" href="mailto:hello@diwa.studio">hello@diwa.studio</a>`
      }
    }
  }
}
</script>

<style scoped>
  section {
    max-width: 600px;
    margin-bottom: 50px;
  }
  .first {
    align-self: end;
  }
  .second {
    align-self: start;
  }
</style>
